import { useCallback } from 'react';

/**
 * A hook that returns error boundary options for React Query v5
 * This can be used in the useQuery options to automatically throw errors to the nearest ErrorBoundary
 */
export function useQueryErrorBoundary() {
  return {
    // v5 name:
    throwOnError: true,
    // keep optional logging (this does not prevent throwing):
    onError: useCallback((err: unknown) => {
      console.error('Query error caught by ErrorBoundary:', err);
    }, [])
    // (no onReset here; that belongs to the ErrorBoundary wrapper)
  };
}
